import { useEffect, useState } from "react";

import {
  Button,
  Typography,
  Container,
  Paper,
  TextField,
  Grid,
  Box,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import { useQuery } from "@tanstack/react-query";
import RebateResultList from "./RebateResultList";
import {
  DetailPageData,
  ProductResultsResponse,
  RebateDataNoUnderscores,
} from "../../../incentive-hub/types/index";
import { ImpProductResultsResponse, PublishedIncentiveData } from "../../../rebatefinder/rebate-result-IMP.tsx/rebate-result-component";
import { Incentive } from "../../../rebatefinder/rebate-result-IMP.tsx/rebate-types";
import Crosswalk from "../../../rebatefinder/Crosswalk/rebate_crosswalk_new.json"
interface NewCrosswalkItem{
  product_unique_name: string,
  product: string,
  rebatefinder_selections: string,
  productfinder_url: string,
  rebatefinder_url: string,
  disappear: string,
  c_id: string
}
interface CrosswalkData{
  crosswalkData: NewCrosswalkItem[]
}
export type customColors = {
  oceanBlueBg: string;
  oceanBlueText: string;

  skyBlueBg: string;
  skyBlueText: string;

  forestGreenBg: string;
  forestGreenText: string;

  slateGrayBg: string;
  slateGrayText: string;

  cloudGrayBg: string;
  cloudGrayText: string;

  midGrayBg: string;
  midGrayText: string;

  sunshineYellowBg: string;
  sunshineYellowText: string;
};

const CustomColors: customColors = {
  oceanBlueBg: "rgb(14, 77, 130)",
  oceanBlueText: "rgb(255, 255, 255)",

  skyBlueBg: "rgb(0, 122, 191)",
  skyBlueText: " rgb(255, 255, 255)",

  forestGreenBg: "rgb(68, 132, 62)",
  forestGreenText: "rgb(255, 255, 255)",

  slateGrayBg: "rgb(61, 65, 68)",
  slateGrayText: "rgb(255, 255, 255)",

  cloudGrayBg: "rgb(245, 245, 245)",
  cloudGrayText: "rgb(0, 0, 0)",

  midGrayBg: "rgb(225, 225, 225)",
  midGrayText: "rgb(0, 0, 0)",

  sunshineYellowBg: "rgb(252, 195, 78)",
  sunshineYellowText: "rgb(0, 0, 0)",
};

type RebateCrosswalk = {
  crosswalk: RebateCrosswalkItem[];
};

type RebateCrosswalkItem = {
  c_id: string;
  product_unique_name: string;
  product: string;
  rebatefinder_selections: string;
  productfinder_url: string;
  rebatefinder_url: string;
  disappear: string | null; //made nullable as data is either "TRUE" or null
};

// getRebatesCrosswalkData gathers full crosswalk reference data -- type assosciate : RebateCrosswalk -- this needs to only run on mount or render of new data

const RebateWidget = ({
  selectedProductUniqueName,
  selectedZipCode,
}: DetailPageData) => {
  const [rebatesCrosswalk, setRebatesCrosswalk] = useState<RebateCrosswalkItem[] | [] >([]); //typed useState -- Allows only a list of type RebateCrosswalk to populate and pass around
  const [productRebateCrosswalk, setProductRebateCrosswalk] =useState<RebateCrosswalkItem>(); //typed useState -- Allows only a single object of type Rebate to populate and pass around
 const [formattedData, setFormattedData] = useState<Object>({})
  const [zip, setZip] = useState<string | null>(selectedZipCode);
  const [zipError, setZipError] = useState(false);
  const [zipHelperText, setZipHelperText] = useState("");
  const [validatedZip, setValidatedZip] = useState<string | null>(selectedZipCode);
  const [rebates, setRebates] = useState<Incentive[] | null | undefined>([]); //typed useState -- Allows only a list of type Rebate to populate and pass around
  const [showAllRebatesButton, setShowAllRebatesButton] = useState(false);
  const [showAllRebates, setShowAllRebates] = useState(false);

  const getRebatesData = async () => {
    const zipCodeParams = "zip_code_filter=" + validatedZip + "&" ;
    const productFilter = productRebateCrosswalk?.rebatefinder_url !== undefined ? productRebateCrosswalk?.rebatefinder_url : "" ;
    const filteredSearchUrl = productFilter
      
      .replace("zip_code_filter=&", zipCodeParams)
   

    const res = await fetch(
      "/productfinder/api/imp_rebate_results/data"  + filteredSearchUrl
    );
    //console.log(res.url);
    return (await res.json()) as Promise<ImpProductResultsResponse>;
  };

  //const queryClient = useQueryClient();
  const { isLoading, isSuccess, isError, data, error } = useQuery(
    [validatedZip, productRebateCrosswalk],
    getRebatesData
  );

  const crosswalkdata = Crosswalk as RebateCrosswalkItem[];

  function validateForm(
    zip: string | null,
    setZipHelperText: React.Dispatch<React.SetStateAction<string>>,
    setZipError: React.Dispatch<React.SetStateAction<boolean>>
  ) {
    const isvalidzip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip ?? "");

    let valid = true;

    if (!isvalidzip) {
      setZipHelperText("Please Enter a Valid Zip");
      setZipError(true);
      valid = false;
    } else {
      setZipHelperText("");
      setZipError(false);
    }

    return valid;
  }

  useEffect(() => {
    validateForm(zip, setZipHelperText, setZipError);
  }, [zip]);

  const prepareDataForDisplay = (data : PublishedIncentiveData[]) => {
    const dataArray : Incentive[] = []
    if(data !== undefined){
      for(const incentive  of data){
        let dataParsed = JSON.parse(incentive.incentivedata) as Incentive
        dataArray.push(dataParsed)
      }
    }
      
      return dataArray
  }

  
  useEffect(() => {
    
    if (data) {


      if (data?.results.length > 1) {
        setShowAllRebatesButton(true);
      } else {
        setShowAllRebatesButton(false);
      }
      if (!showAllRebates) {
        setRebates(prepareDataForDisplay(data.results).slice(0,1));
      } else {
        setRebates(prepareDataForDisplay(data.results));
      }
    }
  }, [ validatedZip,zip, showAllRebates,showAllRebatesButton,rebates, isSuccess]);

  useEffect(() => {
    if (crosswalkdata) {
      setRebatesCrosswalk(crosswalkdata);
      const productDrillDown = crosswalkdata.filter(
        (x: RebateCrosswalkItem) =>
          x.product_unique_name === selectedProductUniqueName
      ); // filter to only the current product
      if (productDrillDown?.length > 0 && productDrillDown?.length < 2) {
        // make sure only a single product returns
        setProductRebateCrosswalk(productDrillDown[0]); // set state with single product crosswalk data
      } else {
        console.log(
          "Filter is not working correctly, length is out of bounds :" +
            productDrillDown
        ); // if more than one product found see result in console
      }
    }
  }, [crosswalkdata]);

  const handleZipChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setZip((event.target as HTMLInputElement).value);
  };

  const handleClick = (e : any) => {
    e.preventDefault()
    if (validateForm(zip, setZipHelperText, setZipError)) {
      setValidatedZip(zip);
    }
  };
  const handleShowAll = (event : any) => {
    event.preventDefault()
    if (showAllRebates) {
      setShowAllRebates(false);
    } else {
      setShowAllRebates(true);
    }
  };

  if (rebates && validatedZip && productRebateCrosswalk?.disappear !== "true") {
    return (
      <Container
        maxWidth="lg"
        disableGutters
        sx={{ marginTop: "20px", marginBottom: "15px" }}
      >
        <Paper
          sx={{
            border: "1px dashed " + CustomColors.skyBlueBg,
            padding: "12px",
            paddingBottom: "10px",
          }}
        >
          <Grid
            container
            spacing={0}
            paddingLeft={1}
            paddingBottom={2}
            marginTop={0}
            marginBottom={0}
            columnSpacing={0}
            rowSpacing={1}
            columns={12}
            bgcolor={CustomColors.oceanBlueBg}
            display="flex"
            flexDirection={"row"}
            alignItems={"center"}
          >
            <Grid item xs={12} md={4}>
              <Typography
                alignItems={"center"}
                
                sx={{
                  fontSize : "1.75em !important",
                  variant: "h3",
                  backgroundColor: CustomColors.oceanBlueBg,
                  color: "white !important",
                  paddingRight: "5px",
                  marginLeft: "25px",
                  fontWeight: "bold"
                }}
              >
                {" "}
                Rebates in your zip code:
              </Typography>
            </Grid>
            <Grid item xs={4} md={2}>
              <label htmlFor="zip_code_input" style={{color: CustomColors.oceanBlueBg, fontSize: 0, height: 0, width:0, marginBottom: -5}}>Enter your zip </label>
              <TextField
              
                id="zip_code_input"
                variant="standard"
                sx={{
                  backgroundColor: CustomColors.cloudGrayBg,
                  width: "130px",
                
                  color: CustomColors.oceanBlueText,
                  
                  
                }}
                aria-label="Enter your zip"
               
                size="medium"
                error={zipError}
                value={zip}
                onChange={handleZipChange}
                inputProps={{ maxLength: 5 }}
                onKeyDown={(e) => {
                  
                  e.key === "Enter" && handleClick(e); }}
              />
            
            </Grid>
            <Grid item xs={8} md={3}>
              <Button
                variant="contained"
                color="success"
                onClick={handleClick}
                sx={{
                  "&:hover": {
                    backgroundColor: "white",
                  },
                  fontWeight: "bold",
                  backgroundColor: 'white',
                  color: CustomColors.oceanBlueBg,
                  marginLeft: "25px",
                }}
              >
                <SearchIcon sx={{ color: CustomColors.oceanBlueBg }} />
                Change Zip
              </Button>
            </Grid>
          </Grid>

          {
            // Passing props to highest component for assimilation into child components -- rebates is of type Rebate[], zip is of type string
          }
          <RebateResultList
            colors={CustomColors}
            data = {rebates}
            zipCode={validatedZip}
          />
        </Paper>
        {showAllRebatesButton ? (
          <Box textAlign="center" marginTop={-1.5}>
            <Button
              variant="outlined"
              size="large"
              onClick={handleShowAll}
              sx={{
                backgroundColor: "white",
                color: CustomColors.oceanBlueBg,
                borderColor: CustomColors.oceanBlueBg,
                fontSize: "0.8rem",
                "&:hover": {
                  backgroundColor: "white",
                  color: CustomColors.oceanBlueBg,
                  borderColor: CustomColors.oceanBlueBg,
                },
              }}
            >
              {showAllRebates
                ? "▲ Collapse Incentives ▲"
                : "▼ Show All Incentives ▼"}
            </Button>
          </Box>
        ) : (
          ""
        )}
      </Container>
    );
  }
};

export default RebateWidget;
